// extracted by mini-css-extract-plugin
export default {"privacy":"TermsOfUse_privacy__6apJ8"};